import { get, find } from "lodash";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import { FilterTags } from "components/FilterTags";
import { Link } from "react-router-dom";
import { Toast } from "primereact/toast";
import { PageRequestError } from "components/PageRequestError";
import { Paginator } from "primereact/paginator";
import { ProgressSpinner } from "primereact/progressspinner";
import { Title } from "components/Title";
import useApp from "hooks/useApp";
import { useNavigate } from "react-router-dom";
import useListPage from "hooks/useListPage";
import CustomDataTable from "components/CustomDataTable";
import { Dropdown } from "primereact/dropdown";
import { Sidebar } from "primereact/sidebar";
import { useEffect, useState, useRef } from "react";
import useApi from "hooks/useApi";
import { Chip } from "primereact/chip";
import ImportFile from "../modules/ImportFile";
import { useTranslation } from "react-i18next";
const apiUrl = process.env.REACT_APP_API_PATH ?? "/api/";

const EventsListPage = (props) => {
  const app = useApp();
  const api = useApi();
  const toastRef = useRef(null);
  const navigate = useNavigate();
  const [load, setLoad] = useState(false);
  const [visible, setVisible] = useState(false);
  const [doctorNames, setDoctorNames] = useState([]);
  const [personnelNames, setPersonnelNames] = useState([]);
  const [patientType, setPatientType] = useState([]);
  const [mrn, setMrn] = useState([]);
  const [encounterNumber, setEncounterNumber] = useState([]);
  const [personnelRole, setPersonnelRole] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedDrName, setSelectedDrName] = useState(null);
  const [selectedPersonnelName, setSelectedpersonnelName] = useState(null);
  const [selectedPatientType, setSelectedPatientType] = useState(null);
  const [selectedMrn, setSelectedMrn] = useState(null);
  const [selectedEncounterNumber, setSelectedEncounterNumber] = useState(null);
  const [selectedPersonnelRole, setSelectedPersonnelRole] = useState(null);
  const [selectedDuration, setSelectedDuration] = useState(null);
  const [chipData, setChipData] = useState([]);
  const [filteredActions, setFilteredActions] = useState([]);
  const [filteredDoctorNames, setFilteredDoctorNames] = useState([]);
  const [filteredMrn, setFilteredMrn] = useState([]);
  const [filteredPersonnelNames, setFilteredPersonnelNames] = useState([]);
  const [filteredPersonnelRole, setFilteredPersonnelRole] = useState([]);
  const [filteredPatientType, setFilteredPatientType] = useState([]);
  const [filteredEncounterNumber, setFilteredEncounterNumber] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [hovered, setHovered] = useState(false);
  const { t } = useTranslation();
  const FACILITIES = t("FACILITIES");
  const MODULE = t("MODULE");
  const EVENTS = t("EVENTS");
  const IMPORT_CSV_FILE = t("IMPORT_CSV_FILE");
  const ADD_NEW_EVENT = t("ADD_NEW_EVENT");
  const RECORDS = t("RECORDS");
  const NO_RECORD_FOUND = t("NO_RECORD_FOUND");
  const FILTER = t("FILTER");
  const APPLY = t("APPLY");
  const CLEAR = t("CLEAR");
  const PERSONNEL_NAME = t("PERSONNEL_NAME");
  const DOCTORS_NAME = t("DOCTORS_NAME");
  const QUEUE_NUMBER = t("QUEUE_NUMBER");
  const DURATION = t("DURATION");
  const PATIENT_TYPE = t("PATIENT_TYPE");
  const ACTIONS = t("ACTIONS");

  const linkStyle = {
    color: hovered ? "blue" : "inherit",
    textDecoration: hovered ? "underline" : "none",
    cursor: "pointer",
  };

  const filterSchema = {
    search: {
      tagTitle: "Search",
      value: "",
      valueType: "single",
      options: [],
    },
  };

  const pageController = useListPage(props, filterSchema, "data");
  const filterController = pageController.filterController;
  const {
    records,
    pageReady,
    loading,
    selectedItems,
    sortBy,
    sortOrder,
    apiRequestError,
    setSelectedItems,
    getPageBreadCrumbs,
    onSort,
    deleteItem,
    pagination,
    refetch,
  } = pageController;
  const {} = filterController;
  const {
    totalRecords,
    totalPages,
    recordsPosition,
    firstRow,
    limit,
    onPageChange,
  } = pagination;

  useEffect(() => {
    const getEvents = `events/get_all_events`;
    api
      .get(getEvents)
      .then((res) => {
        setDoctorNames(get(res, "data.data", []));
        setMrn(get(res, "data.data", []));
        setPersonnelNames(get(res, "data.data", []));
        setPersonnelRole(get(res, "data.data", []));
        setPatientType(get(res, "data.data", []));
        setEncounterNumber(get(res, "data.data", []));
      })
      .catch((e) => {
        setDoctorNames([]);
        setMrn([]);
        setPersonnelNames([]);
        setPersonnelRole([]);
        setPatientType([]);
        setEncounterNumber([]);
      });
  }, [app.selectedOrg]);

  useEffect(() => {
    if (selectedModule) {
      const filteredActions = app.actions.filter(
        (action) => action.module_id === selectedModule.id
      );
      setFilteredActions(filteredActions);
      setSelectedAction(null);
    } else {
      setFilteredActions([]);
      setSelectedAction(null);
    }
  }, [selectedModule, app.actions]);

  useEffect(() => {
    if (selectedModule) {
      const filteredDoctorNames = doctorNames.filter(
        (doctorName, index, self) =>
          index ===
            self.findIndex(
              (t) =>
                t.dr_name === doctorName.dr_name &&
                t.module_id === doctorName.module_id
            ) && doctorName.module_id === selectedModule.id
      );
      setFilteredDoctorNames(filteredDoctorNames);
      setSelectedDrName(null);
    }
  }, [selectedModule, doctorNames]);

  useEffect(() => {
    if (selectedModule) {
      const filteredMrn = mrn.filter(
        (mrnItem, index, self) =>
          index ===
            self.findIndex(
              (t) => t.mrn === mrnItem.mrn && t.module_id === mrnItem.module_id
            ) && mrnItem.module_id === selectedModule.id
      );
      setFilteredMrn(filteredMrn);
      setSelectedMrn(null);
    }
  }, [selectedModule, mrn]);

  useEffect(() => {
    if (selectedModule) {
      const filteredPersonnelNames = personnelNames.filter(
        (personnelName, index, self) =>
          index ===
            self.findIndex(
              (t) =>
                t.personnel_name === personnelName.personnel_name &&
                t.module_id === personnelName.module_id
            ) && personnelName.module_id === selectedModule.id
      );
      setFilteredPersonnelNames(filteredPersonnelNames);
      setSelectedpersonnelName(null);
    }
  }, [selectedModule, personnelNames]);

  useEffect(() => {
    if (selectedModule) {
      const filteredPersonnelRole = personnelRole.filter(
        (role, index, self) =>
          index ===
            self.findIndex(
              (t) =>
                t.personnel_role === role.personnel_role &&
                t.module_id === role.module_id
            ) && role.module_id === selectedModule.id
      );
      setFilteredPersonnelRole(filteredPersonnelRole);
      setSelectedPersonnelRole(null);
    }
  }, [selectedModule, personnelRole]);

  useEffect(() => {
    if (selectedModule) {
      const filteredPatientType = patientType.filter(
        (type, index, self) =>
          index ===
            self.findIndex(
              (t) =>
                t.patient_type === type.patient_type &&
                t.module_id === type.module_id
            ) && type.module_id === selectedModule.id
      );
      setFilteredPatientType(filteredPatientType);
      setSelectedPatientType(null);
    }
  }, [selectedModule, patientType]);

  useEffect(() => {
    if (selectedModule) {
      const filteredEncounterNumber = encounterNumber.filter(
        (encounter, index, self) =>
          index ===
            self.findIndex(
              (t) =>
                t.encounter_number === encounter.encounter_number &&
                t.module_id === encounter.module_id
            ) && encounter.module_id === selectedModule.id
      );
      setFilteredEncounterNumber(filteredEncounterNumber);
      setSelectedEncounterNumber(null);
    }
  }, [
    selectedModule,
    encounterNumber,
    doctorNames,
    personnelNames,
    personnelRole,
    mrn,
    patientType,
  ]);
  useEffect(() => {
    const filterUniqueItems = (items, key) => {
      const seen = new Set();
      return items.filter((item) => {
        const itemKey = item[key];
        if (!itemKey && itemKey !== 0) {
          return false;
        }
        if (seen.has(itemKey)) {
          return false;
        } else {
          seen.add(itemKey);
          return true;
        }
      });
    };

    const filterByModule = (items, key) => {
      if (selectedModule) {
        return items.filter((item) => item.module_id === selectedModule.id);
      }
      return items;
    };

    const updateFilteredItems = (items, setFilteredItems, key) => {
      const filteredByModule = filterByModule(items, key);
      const uniqueFilteredItems = filterUniqueItems(filteredByModule, key);
      setFilteredItems(uniqueFilteredItems);
    };

    updateFilteredItems(doctorNames, setFilteredDoctorNames, "dr_name");
    updateFilteredItems(
      personnelNames,
      setFilteredPersonnelNames,
      "personnel_name"
    );
    updateFilteredItems(mrn, setFilteredMrn, "mrn");
    updateFilteredItems(patientType, setFilteredPatientType, "patient_type");
    updateFilteredItems(
      personnelRole,
      setFilteredPersonnelRole,
      "personnel_role"
    );
    updateFilteredItems(
      encounterNumber,
      setFilteredEncounterNumber,
      "encounter_number"
    );

    setSelectedDrName(null);
    setSelectedpersonnelName(null);
    setSelectedMrn(null);
    setSelectedPatientType(null);
    setSelectedPersonnelRole(null);
    setSelectedEncounterNumber(null);
  }, [
    selectedModule,
    doctorNames,
    personnelNames,
    mrn,
    patientType,
    personnelRole,
    encounterNumber,
  ]);

  const constructFilterObject = () => {
    const filterObj = {};
    if (selectedModule) {
      filterObj.module_id = selectedModule.id;
    }
    if (app.selectedOrg) {
      filterObj.org_code = app.selectedOrg.code;
    }
    if (selectedAction) {
      filterObj.action_id = selectedAction.id;
    }
    if (selectedDrName) {
      filterObj.dr_name = selectedDrName.dr_name;
    }
    if (selectedMrn) {
      filterObj.mrn = selectedMrn.mrn;
    }
    if (selectedPersonnelName) {
      filterObj.personnel_name = selectedPersonnelName.personnel_name;
    }
    if (selectedPatientType) {
      filterObj.patient_type = selectedPatientType.patient_type;
    }
    if (selectedPersonnelRole) {
      filterObj.personnel_role = selectedPersonnelRole.personnel_role;
    }
    if (selectedEncounterNumber) {
      filterObj.encounter_number = selectedEncounterNumber.encounter_number;
    }
    if (selectedDuration) {
      filterObj.duration = selectedDuration.duration;
    }
    return filterObj;
  };

  const eventFilterHandler = () => {
    const filterObj = constructFilterObject();
    let chipArray = [];

    if (filterObj.action_id !== undefined) {
      chipArray.push(selectedAction.action_name);
    }

    if (filterObj.org_code !== undefined) {
      chipArray.push(app.selectedOrg.name);
    }

    if (filterObj.module_id !== undefined) {
      chipArray.push(selectedModule.module_name);
    }

    chipArray = [
      ...chipArray,
      ...Object.values(filterObj).filter(
        (val, index) =>
          !["action_id", "org_code", "module_id"].includes(
            Object.keys(filterObj)[index]
          )
      ),
    ];

    setChipData(chipArray);

    let combinedFilterString = "";
    for (const key in filterObj) {
      if (filterObj.hasOwnProperty(key)) {
        combinedFilterString += `${key}=${filterObj[key]},`;
      }
    }

    // Remove the trailing comma
    combinedFilterString = combinedFilterString.slice(0, -1);
    app.setEventFilterParameters(combinedFilterString);
    setVisible(false);
  };

  useEffect(() => {
    eventFilterHandler();
    return () => {
      app.setEventFilterParameters();
    };
  }, [app.selectedOrg]);

  const clearEventHandler = () => {
    app.setEventFilterParameters("");
    setVisible((prevState) => !prevState);
    setSelectedAction(null);
    setSelectedDrName(null);
    setSelectedDuration(null);
    setSelectedEncounterNumber(null);
    setSelectedModule(null);
    setSelectedMrn(null);
    setSelectedPatientType(null);
    setSelectedPersonnelRole(null);
    setSelectedpersonnelName(null);
    setChipData([]);
  };
  const removeChip = (chipToRemove) => {
    const updatedChips = chipData.filter((chip) => chip !== chipToRemove);
    setChipData(updatedChips);

    if (chipToRemove === selectedAction?.action_name) {
      setSelectedAction(null);
    } else if (chipToRemove === app.selectedOrg?.name) {
      app.setSelectedOrg(null);
    } else if (chipToRemove === selectedModule?.module_name) {
      setSelectedModule(null);
    } else if (chipToRemove === selectedDrName?.dr_name) {
      setSelectedDrName(null);
    } else if (chipToRemove === selectedMrn?.mrn) {
      setSelectedMrn(null);
    } else if (chipToRemove === selectedPersonnelName?.personnel_name) {
      setSelectedpersonnelName(null);
    } else if (chipToRemove === selectedPersonnelRole?.personnel_role) {
      setSelectedPersonnelRole(null);
    } else if (chipToRemove === selectedPatientType?.patient_type) {
      setSelectedPatientType(null);
    } else if (chipToRemove === selectedEncounterNumber?.encounter_number) {
      setSelectedEncounterNumber(null);
    }
    const updatedFilterObj = {};
    updatedChips.forEach((chip) => {
      if (chip === selectedAction?.action_name) {
        updatedFilterObj.action_id = selectedAction.id;
      } else if (chip === app.selectedOrg?.name) {
        updatedFilterObj.org_code = app.selectedOrg.code;
      } else if (chip === selectedModule?.module_name) {
        updatedFilterObj.module_id = selectedModule.id;
      } else if (chip === selectedDrName?.dr_name) {
        updatedFilterObj.dr_name = selectedDrName.dr_name;
      } else if (chip === selectedMrn?.mrn) {
        updatedFilterObj.mrn = selectedMrn.mrn;
      } else if (chip === selectedPersonnelName?.personnel_name) {
        updatedFilterObj.personnel_name = selectedPersonnelName.personnel_name;
      } else if (chip === selectedPersonnelRole?.personnel_role) {
        updatedFilterObj.personnel_role = selectedPersonnelRole.personnel_role;
      } else if (chip === selectedPatientType?.patient_type) {
        updatedFilterObj.patient_type = selectedPatientType.patient_type;
      } else if (chip === selectedEncounterNumber?.encounter_number) {
        updatedFilterObj.encounter_number =
          selectedEncounterNumber.encounter_number;
      }
    });
    const combinedFilterString = Object.entries(updatedFilterObj)
      .filter(([key, value]) => value !== null && value !== undefined)
      .map(([key, value]) => `${key}=${value}`)
      .join(",");
    app.setEventFilterParameters(combinedFilterString);
    refetch();
  };
  function IdTemplate(data) {
    if (data) {
      return <Link to={`/events/view/${data.id}`}> {data.id}</Link>;
    }
  }
  const handleRowClick = (event) => {
    const rowData = event.data;
    navigate(`/events/view/${rowData.id}`);
  };
  function EmailTemplate(data) {
    if (data) {
      return (
        <a className="p-button-text" href={`mailto:${data.email}`}>
          {data.email}
        </a>
      );
    }
  }

  function OrganisationTemplate(data) {
    const org = find(app.organisations, (org) => org.code === data.org_code);
    if (org) {
      return org.name;
    } else {
      return "-";
    }
  }
  function ModuleTemplate(data) {
    const module = find(app.modules, (module) => module.id === data.module_id);
    if (module) {
      return module.module_name;
    } else {
      return "-";
    }
  }
  function ActionTemplate(data) {
    const action = find(app.actions, (action) => action.id === data.action_id);
    if (action) {
      return action.action_name;
    } else {
      return "-";
    }
  }

  function PageLoading() {
    if (loading) {
      return (
        <>
          <div className="flex align-items-center justify-content-center text-gray-500 p-3">
            <div>
              <ProgressSpinner style={{ width: "30px", height: "30px" }} />{" "}
            </div>
            <div className="font-bold text-lg">Loading...</div>
          </div>
        </>
      );
    }
  }
  function EmptyRecordMessage() {
    if (pageReady && !records.length) {
      return (
        <div className="text-lg mt-3 p-3 text-center text-400 font-bold">
          {NO_RECORD_FOUND}
        </div>
      );
    }
  }

  function PagerControl() {
    setLoad(true);
    if (props.paginate && totalPages > 1) {
      const pagerReportTemplate = {
        layout: pagination.layout,
        CurrentPageReport: (options) => {
          return (
            <>
              <span className="text-sm text-gray-500 px-2">
                {RECORDS}{" "}
                <b>
                  {recordsPosition} {t("OF")} {options.totalRecords}
                </b>
              </span>
            </>
          );
        },
      };
      return (
        <div className="flex-grow-1">
          <Paginator
            first={firstRow}
            rows={limit}
            totalRecords={totalRecords}
            onPageChange={onPageChange}
            template={pagerReportTemplate}
          />
        </div>
      );
    }
    setLoad(false);
  }
  function PageFooter() {
    if (pageReady && props.showFooter) {
      return (
        <div className="flex flex-wrap justify-content-between">
          <PagerControl />
        </div>
      );
    }
  }
  function PageBreadcrumbs() {
    if (props.showBreadcrumbs) {
      const items = getPageBreadCrumbs();
      return items.length > 0 && <BreadCrumb className="mb-3" model={items} />;
    }
  }
  if (apiRequestError) {
    return <PageRequestError error={apiRequestError} />;
  }
  return (
    <main id="EventsListPage" className="main-page">
      <Toast ref={toastRef} />
      {props.showHeader && (
        <section className="page-section mb-3">
          <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
              <div className=" flex gap-3">
                <Title
                  title={EVENTS}
                  titleClass="text-2xl text-primary font-bold"
                  subTitleClass="text-500"
                  separator={false}
                />
                {chipData.length > 0 && (
                  <div style={{ marginTop: "0px" }}>
                    <p>{t("FILTERED_BY")}:- </p>
                  </div>
                )}
                {chipData?.map((name) => (
                  <div key={name} style={{ marginTop: "0px" }}>
                    <Chip
                      style={{
                        height: "35px",
                        fontSize: "12px",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "210px",
                        paddingRight: "20px",
                      }}
                      label={
                        name.length > 30 ? `${name.slice(0, 27)}...` : name
                      }
                      className="p-mr-2 p-mb-2"
                      removable
                      removeIcon="pi pi-times"
                      onClick={() => removeChip(name)}
                    />
                  </div>
                ))}
              </div>
              <div className="grid justify-content-between align-items-center gap-2">
                <div className="p-inputgroup flex-1">
                  <Button
                    icon="pi pi-filter"
                    onClick={() => setVisible(true)}
                    tooltip={FILTER}
                  />
                  <Sidebar
                    visible={visible}
                    position="right"
                    onHide={() => setVisible(false)}
                    dismissable={false}
                  >
                    <h4>{t("APPLY_FILTERS")}</h4>
                    <div className=" flex flex-column gap-3">
                      <Dropdown
                        loading
                        showClear
                        filter
                        emptyFilterMessage={t("NO_OPTIONS_FOUND")}
                        value={selectedModule}
                        onChange={(e) => setSelectedModule(e.value)}
                        options={app.modules}
                        optionLabel="module_name"
                        placeholder={t("SELECT_MODULE")}
                        appendTo="self"
                        className="w-full md:w-16rem"
                      />
                      <Dropdown
                        loading
                        showClear
                        filter
                        emptyFilterMessage={t("NO_OPTIONS_FOUND")}
                        emptyMessage={t("NO_RECORDS_FOUND")}
                        value={selectedAction}
                        onChange={(e) => setSelectedAction(e.value)}
                        options={filteredActions}
                        optionLabel="action_name"
                        placeholder={
                          selectedModule
                            ? t("SELECT_ACTION")
                            : t("SELECT_MODULE_FIRST")
                        }
                        appendTo="self"
                        className="w-full md:w-16rem"
                      />
                      <Dropdown
                        loading
                        showClear
                        filter
                        emptyFilterMessage={t("NO_OPTIONS_FOUND")}
                        value={selectedDrName}
                        onChange={(e) => setSelectedDrName(e.value)}
                        options={filteredDoctorNames}
                        placeholder={t("SELECT_DOCTOR_NAME")}
                        appendTo="self"
                        className="w-full md:w-16rem"
                        optionLabel="dr_name"
                      />
                      <Dropdown
                        loading
                        showClear
                        filter
                        emptyFilterMessage={t("NO_OPTIONS_FOUND")}
                        value={selectedMrn}
                        onChange={(e) => setSelectedMrn(e.value)}
                        options={filteredMrn}
                        optionLabel="mrn"
                        placeholder={t("SELECT_MRN")}
                        appendTo="self"
                        className="w-full md:w-16rem"
                      />
                      <Dropdown
                        loading
                        showClear
                        filter
                        emptyFilterMessage={t("NO_OPTIONS_FOUND")}
                        value={selectedPersonnelName}
                        onChange={(e) => setSelectedpersonnelName(e.value)}
                        options={filteredPersonnelNames}
                        optionLabel="personnel_name"
                        placeholder={t("SELECT_PERSONNEL_NAME")}
                        appendTo="self"
                        className="w-full md:w-16rem"
                      />
                      <Dropdown
                        loading
                        showClear
                        filter
                        emptyFilterMessage={t("NO_OPTIONS_FOUND")}
                        value={selectedPersonnelRole}
                        onChange={(e) => setSelectedPersonnelRole(e.value)}
                        options={filteredPersonnelRole}
                        optionLabel="personnel_role"
                        placeholder={t("SELECT_PERSONNEL_ROLE")}
                        appendTo="self"
                        className="w-full md:w-16rem"
                      />
                      <Dropdown
                        loading
                        showClear
                        filter
                        emptyFilterMessage={t("NO_OPTIONS_FOUND")}
                        value={selectedPatientType}
                        onChange={(e) => setSelectedPatientType(e.value)}
                        options={filteredPatientType}
                        optionLabel="patient_type"
                        placeholder={t("SELECT_PATIENT_TYPE")}
                        appendTo="self"
                        className="w-full md:w-16rem"
                      />
                      <Dropdown
                        loading
                        showClear
                        filter
                        emptyFilterMessage={t("NO_OPTIONS_FOUND")}
                        value={selectedEncounterNumber}
                        onChange={(e) => setSelectedEncounterNumber(e.value)}
                        options={filteredEncounterNumber}
                        optionLabel="encounter_number"
                        placeholder={t("SELECT_ENCOUNTER_NUMBER")}
                        appendTo="self"
                        className="w-full md:w-16rem"
                      />
                      {/* <Dropdown loading showClear filter value={selectedDuration}  onChange={(e) => setSelectedDuration(e.value)}  options={duration} placeholder="choose duration" appendTo="self" className="w-full md:w-16rem"/> */}
                    </div>
                    <div className="flex justify-around mt-4">
                      <Button
                        onClick={eventFilterHandler}
                        className="p-button w-5 bg-primary"
                        label={APPLY}
                      />
                      <Button
                        onClick={clearEventHandler}
                        className="p-button w-5 bg-primary"
                        label={CLEAR}
                      />
                    </div>
                  </Sidebar>
                </div>
                <ImportFile
                  toastRef={toastRef}
                  label={IMPORT_CSV_FILE}
                  onUploadStart={() => setUploading(true)}
                  onUploadEnd={() => {
                    setUploading(false);
                    refetch();
                  }}
                  url={`events/upload`}
                  accept=".csv"
                  disabled={uploading}
                />
                {uploading ? "Uploading..." : ""}
                <Link to={`/events/add`}>
                  <Button
                    label={ADD_NEW_EVENT}
                    icon="pi pi-plus"
                    type="button"
                    className="p-button w-full bg-primary "
                  />
                </Link>
              </div>
            </div>
          </div>
        </section>
      )}
      <section className="page-section ">
        <div className="container-fluid">
          <div className="grid ">
            <div className="col comp-grid">
              <FilterTags filterController={filterController} />
              <div>
                <PageBreadcrumbs />
                <div className="page-records">
                  <CustomDataTable
                    loading={loading}
                    data={records}
                    selectionMode="checkbox"
                    selectedItems=""
                    onSelectionChange={(e) => setSelectedItems(e.value)}
                    sortField={sortBy}
                    sortOrder={sortOrder}
                    onSort={onSort}
                    rowClickHandler={handleRowClick}
                    emptyMessage={<EmptyRecordMessage />}
                    columns={[
                      { field: "id", header: "Id", body: IdTemplate },
                      {
                        field: "org_code",
                        header: FACILITIES,
                        body: OrganisationTemplate,
                      },
                      {
                        field: "module_id",
                        header: MODULE,
                        body: ModuleTemplate,
                      },
                      {
                        field: "action_id",
                        header: ACTIONS,
                        body: ActionTemplate,
                      },
                      { field: "dr_name", header: DOCTORS_NAME },
                      {
                        field: "personnel_name",
                        header: PERSONNEL_NAME,
                        body: (rowData) => (
                          <Link
                            to={`/patient/${rowData.mrn}`}
                            style={linkStyle}
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)}
                          >
                            {rowData.personnel_name}
                          </Link>
                        ),
                      },
                      { field: "patient_type", header: PATIENT_TYPE },
                      { field: "duration", header: DURATION },
                      { field: "queue_number", header: QUEUE_NUMBER },
                    ]}
                  />
                </div>
                <PageFooter />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
const withDefaultProps = (Component) => {
  const WrappedComponent = (props) => {
    const { t } = useTranslation();
    const defaultProps = {
      primaryKey: "id",
      pageName: "events",
      apiPath: "events/get_all_events",
      filterApiPath: "events/get_by_org_code",
      routeName: "eventslist",
      msgBeforeDelete: t("ARE_YOU_SURE_TO_DELETE_EVENT"),
      msgTitle: t("DELETE_EVENT"),
      msgAfterDelete: t("EVENT_DELETED_SUCCESSFULLY"),
      showHeader: true,
      showFooter: true,
      paginate: true,
      isSubPage: false,
      showBreadcrumbs: true,
      exportData: false,
      importData: false,
      keepRecords: false,
      multiCheckbox: true,
      search: "",
      fieldName: null,
      fieldValue: null,
      sortField: "id",
      sortDir: "asc",
      pageNo: 1,
      limit: 10,
    };
    return <Component {...defaultProps} {...props} />;
  };

  return WrappedComponent;
};
export default withDefaultProps(EventsListPage);
